import { render, staticRenderFns } from "./PraticeCommunicationAndMarketingPostSection.vue?vue&type=template&id=4600b1c8"
import script from "./PraticeCommunicationAndMarketingPostSection.vue?vue&type=script&lang=ts"
export * from "./PraticeCommunicationAndMarketingPostSection.vue?vue&type=script&lang=ts"
import style0 from "./PraticeCommunicationAndMarketingPostSection.vue?vue&type=style&index=0&id=4600b1c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports